/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetNotLaunchedProjectsQuery } from '../../models/get-not-launched-projects-query';
import { GetNotLaunchedProjectsQueryResult } from '../../models/get-not-launched-projects-query-result';

export interface ApiProjectGetNotLaunchedProjectsPost$Plain$Params {
      body?: GetNotLaunchedProjectsQuery
}

export function apiProjectGetNotLaunchedProjectsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectGetNotLaunchedProjectsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNotLaunchedProjectsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectGetNotLaunchedProjectsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetNotLaunchedProjectsQueryResult>;
    })
  );
}

apiProjectGetNotLaunchedProjectsPost$Plain.PATH = '/api/Project/GetNotLaunchedProjects';
